import { z } from 'zod'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { addCustomIssue } from 'utils/schema.util'

export const TeenangerProcessHearingSchema = z
  .object({
    id: z.number().nullish(),
    nomeAdolescente: z.string().min(1, SystemMessages.MESSAGE_002),
    status: z.string().min(1, SystemMessages.MESSAGE_002),
    dataAgendamento: z.string().nullish(),
    motivo: z.string().nullish(),
    justificativa: z.string().nullish(),
    notificacoes: z.array(z.string()).nullish(),
    oitiva: z
      .object({
        id: z.number().nullish(),
      })
      .nullish(),
    indicadorIntegracao: z.string().nullish(),
  })
  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)

    if (fields.status === 'NAO_REALIZADO' && !fields.motivo) {
      addIssue('motivo', SystemMessages.MESSAGE_002)
    }

    if (fields.motivo === 'OUTROS' && (!fields.justificativa || fields.justificativa === '')) {
      addIssue('justificativa', SystemMessages.MESSAGE_002)
    }

    if (fields.status === 'AGENDADO' && !fields.dataAgendamento) {
      addIssue('dataAgendamento', SystemMessages.MESSAGE_002)
    }
  })

export type TeenagerProcessHearingType = z.infer<typeof TeenangerProcessHearingSchema>

export const TeenangerProcessHearingDefaultValues: TeenagerProcessHearingType = {
  nomeAdolescente: '',
  status: 'PENDENTE',
}
